import { createFileRoute } from "@tanstack/react-router";

import { MacPermissionsPanel } from "../components/settings/MacPermissionsPanel";

function SettingsPermissionsRoute() {
  return <MacPermissionsPanel />;
}

export const Route = createFileRoute("/settings/permissions")({
  component: SettingsPermissionsRoute,
});
